import update from 'immutability-helper'
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { deleteTabChildNode } from '../../actions/index'
/**
 * 修改 anchor tabs config
 */
export function updateTabConfig(node: any, action) {
  const { key, value, index } = action

  if (index < 0) {
    return node
  }
  if (key === '') {
    // delete
    node = update(node, {
      config: {
        tabs: {
          $splice: [[index, 1]],
        },
      },
    })
  } else if (!node.config.tabs || index >= node.config.tabs.length) {
    // add
    node = update(node, {
      config: {
        tabs: (tabs?: Array<any>) => {
          return update(tabs || [], {
            $push: [
              {
                [key]: value,
              },
            ],
          })
        },
        activeIndex: {
          $apply: function (index: number) {
            return index || 0
          },
        },
      },
    })
  } else {
    // update
    node = update(node, {
      config: {
        tabs: {
          [index]: {
            [key]: {
              $set: value,
            },
          },
        },
      },
    })
  }
  return node
}

export function updateActiveIndex(node: any, action) {
  const { index } = action

  return update(node, {
    config: {
      activeIndex: {
        $set: index,
      },
    },
  })
}

export function updateTabBase(node: any, action) {
  return update(node, {
    config: {
      [action.name]: {
        $set: action.value,
      },
    },
  })
}

export function deleteTabChild(node: any, action) {
  return update(node, {
    $apply: function (node) {
      console.log(node)
      const itemArray = Object.keys(node)
      for (let index = 0; index < itemArray.length; index++) {
        if (node[itemArray[index]].pid === action.id) {
          if (node[itemArray[index]].config.anchor === action.index) {
            const ind = node[action.id].childrens.indexOf(node[itemArray[index]].id)
            node[action.id].childrens.splice(ind, 1)
            delete node[itemArray[index]]
          } else if (
            node[itemArray[index]].config.anchor &&
            node[itemArray[index]].config.anchor > action.index
          ) {
            node[itemArray[index]].config.anchor = node[itemArray[index]].config.anchor - 1
          }
        }
        if (index + 1 === itemArray.length) {
          return node
        }
      }
    },
  })
}
